import router from './router'
import axios from 'axios'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import '@/assets/base.css'
import '@/assets/listPage.css'
import qs from 'qs';
import store from './store/store.js';
import * as Sentry from '@sentry/vue';
import NP from 'number-precision'
import {getCurrentCompanyUUID} from './utils/company';
import i18n from './i18n'


Vue.config.productionTip = false;
Vue.use(ElementUI, {locale});
Vue.use(i18n);


/*axios配置部分*/
let axiosIns = axios.create({});
if (process.env.NODE_ENV == 'development') {
    // axiosIns.defaults.baseURL = 'http://dev.zuliup.cn/';
    axiosIns.defaults.baseURL = 'https://testapi.goodinvoice.com/';
} else if (process.env.NODE_ENV == 'production') {
    axiosIns.defaults.baseURL = 'https://service.goodinvoice.com/';
    Sentry.init({
        Vue: Vue,
        dsn: 'https://bf07658628384433972e2bb4ed476541@sentry.io/1809464',
        attachProps: true,
        logErrors: true,
    });
}
store.commit("setRequestURL", axiosIns.defaults.baseURL);
axiosIns.defaults.responseType = 'json';
axiosIns.defaults.transformRequest = [
    function (data) {
        //数据序列化
        return qs.stringify(data);
    }
];
axiosIns.defaults.timeout = 10000;
axiosIns.interceptors.request.use(function (config) {
    let requestUrl = config.url;
    // console.log(requestUrl)

    if (!localStorage.getItem("loginInformation") && !isPublicAuthRequest(requestUrl)) {
        ElementUI.Message({
            type: "error",
            message: i18n.t('network.loginExpired'),
            duration: "2000",
        });
        router.push('/login');
        return;
    }
    //配置config
    config.headers.Accept = 'application/json';
    appendCompanyUUID(config.data.params, requestUrl);
    config.data = {params: aes_encrypted(config.data.params, requestUrl)}
    return config;
});
axiosIns.interceptors.response.use(function (response) {
    let status = response.status;
    if (status === 200) {
        if (response.data.errorCode == '216') {
            // console.log("我进入打回登录页")
            localStorage.clear();
            // location.reload();
            router.push('/login');

            ElementUI.Message({
                type: "error",
                message: i18n.t('network.loginExpired'),
                duration: "2000",
            });
            return;
        }
        //业务逻辑错误,统一处理
        if (response.data.errorCode != 0) {
            ElementUI.Message({
                type: "error",
                message: response.data.errorMsg,
                duration: "2000",
            });
        }
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
}, function (error) {
    // 响应错误提示
    ElementUI.Message({
        type: "error",
        message: i18n.t('network.requestTimeout'),
        duration: "700",
    });
    return Promise.reject(error);
});

NP.enableBoundaryChecking(false); // default param is true

Vue.prototype.$axios = axiosIns;
Vue.prototype.$NP = NP;

function isPublicAuthRequest(requestUrl) {
    return requestUrl === 'login.htm'
        || requestUrl === 'create_invoice_user'
        || requestUrl === 'send_reset_password_email'
        || requestUrl === 'social_login'
        || requestUrl === 'bind_social_login';
}

function shouldAppendTopLevelCompanyUUID(requestUrl) {
    if (requestUrl === 'get_auth') {
        return true;
    }
    if (requestUrl === 'create_tax_info' || (requestUrl != null && requestUrl.endsWith('/create_tax_info'))) {
        return true;
    }
    if (requestUrl === 'login.htm'
        || requestUrl === 'login_out'
        || requestUrl === 'create_invoice_user'
        || requestUrl === 'send_reset_password_email'
        || requestUrl === 'social_login'
        || requestUrl === 'bind_social_login'
        || requestUrl === 'web_create_company'
        || requestUrl === 'query_setting_and_company'
        || requestUrl === 'update_setting_and_company'
        || requestUrl === 'web_query_invoice'
        || requestUrl === 'query_item'
        || requestUrl === 'query_item_inventory_list'
        || requestUrl === 'query_user_client'
        || requestUrl === 'query_expense_for_web'
        || requestUrl === 'query_total_outstanding_balance') {
        return false;
    }
    if (requestUrl != null && requestUrl.endsWith('/update_setting_and_company')) {
        return false;
    }
    if (requestUrl === 'web_create_invoice' || requestUrl === 'web_create_expense') {
        return false;
    }
    return requestUrl.indexOf('query_') !== -1 || requestUrl.indexOf('create_') !== -1 || requestUrl.indexOf('update_') !== -1;
}

function addCompanyUUIDToObject(target, companyUUID) {
    if (target == null || Array.isArray(target) || typeof target !== 'object') {
        return;
    }
    target.companyUUID = companyUUID;
}

function addCompanyUUIDToList(targetList, companyUUID) {
    if (!Array.isArray(targetList)) {
        return;
    }
    for (let i = 0; i < targetList.length; i++) {
        addCompanyUUIDToObject(targetList[i], companyUUID);
    }
}

function appendCompanyUUIDForSaveRequest(params, requestUrl, companyUUID) {
    if (requestUrl === 'web_create_invoice') {
        addCompanyUUIDToList(params.itemList, companyUUID);
        addCompanyUUIDToObject(params.userClient, companyUUID);
        addCompanyUUIDToList(params.payHistoryList, companyUUID);
        addCompanyUUIDToList(params.invoiceImageList, companyUUID);
        addCompanyUUIDToList(params.taxInfoList, companyUUID);
        addCompanyUUIDToObject(params.invoice, companyUUID);
        if (params.invoice != null && !Array.isArray(params.invoice) && typeof params.invoice === 'object') {
            params.invoice.clientUUID = params.invoice.clientUUIDKey;
        }
        return;
    }

    if (requestUrl === 'web_create_expense') {
        addCompanyUUIDToObject(params.expense, companyUUID);
        addCompanyUUIDToList(params.categoryList, companyUUID);
        addCompanyUUIDToObject(params.companyLogo, companyUUID);
    }
}

function appendCompanyUUID(params, requestUrl) {
    const companyUUID = getCurrentCompanyUUID();
    if (companyUUID === '') {
        return;
    }

    if (shouldAppendTopLevelCompanyUUID(requestUrl)) {
        params.companyUUID = companyUUID;
    }
    appendCompanyUUIDForSaveRequest(params, requestUrl, companyUUID);
}

function aes_encrypted(encryptedParams, requestUrl) {
    // console.log(requestUrl)
    let milliseconds = Date.parse(new Date());
    if (localStorage.getItem("loginInformation")) {
        let loginInformation = JSON.parse(localStorage.getItem("loginInformation")).objectData;
        if (loginInformation) {
            encryptedParams.userUuid = loginInformation.userUuid;
            if (encryptedParams.email == null) {
                encryptedParams.email = loginInformation.email;
            }
        }
    } else {
        if (!isPublicAuthRequest(requestUrl)) {

            ElementUI.Message({
                type: "error",
                message: i18n.t('network.loginExpired'),
                duration: "2000",
            });
            router.push('/login');
        }

    }

    encryptedParams.reqToken = milliseconds;
    encryptedParams.clientInfo = navigator.userAgent;
    encryptedParams.language = "zhcn";
    encryptedParams.fromClient = 3;
    return JSON.stringify(encryptedParams);
}


new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')
